<template>
  <section v-show="navigationMenuStore.showSlideOverEnrolUser" class="fixed inset-0 overflow-hidden" style="z-index: 2147483002" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <div class="absolute inset-0">
      <!-- Background overlay, show/hide based on slide-over state. -->
      <div class="absolute inset-0 bg-gray-600 opacity-50" aria-hidden="true"></div>

      <div class="absolute inset-y-0 pl-16 max-w-full right-0 flex">
        <transition
            name="display-user-enroll"
            enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
            enter-class="translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
            leave-class="translate-x-0"
            leave-to-class="translate-x-full">

          <div v-show="navigationMenuStore.showSlideOverEnrolUser" class="opacity-100 divide-y divide-gray-200 flex flex-col bg-white shadow-xl rounded-md">
            <!-- Si no se ha seleccionado ningún curso/producto -->
            <div v-show="this.projectSelected.title === ''" class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl">
              <div class="flex flex-col overflow-y-auto">
                <div class="flex justify-between py-6 bg-bpblue">
                  <span class="mt-1 ml-6 text-white font-bold text-2xl">Selecciona un curso</span>
                  <div class="mt-2 mr-8">
                    <button type="button" v-on:click="navigationMenuStore.toggleSlideOverEnrolUser" class=" rounded-md text-brainspro-100 hover:text-white focus:outline-none focus:ring-2 focus:ring-white">
                      <span class="sr-only">Close panel</span>
                      <!-- Heroicon name: outline/x -->
                      <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div v-if="loading" class="flex justify-center w-screen max-w-md mt-7 p-4 text-sm ">
                  <div class=" text-yellow-700">
                    <svg class="inline mr-3 w-4 h-4 text-blue-700 animate-spin" viewBox="0 0 100 101" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"/>
                      <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"/>
                    </svg>
                  </div>
                  <span class="ml-1 text-gray-400">
                    Cargando cursos...
                   </span>
                </div>
                <div class="w-full border-t border-gray-200"></div>
                <div class="overflow-y-auto grow">
                  <div v-for="project in projects" :key="project.uuid" class="hover:bg-blue-100 transition-colors ease-in">
                    <div v-on:click="getProjectSelected(project)"
                         class="px-6 py-4 whitespace-no-wrap border-b border-gray-200 cursor-pointer">
                      <div class="flex items-center ">
                        <div class="flex-shrink-0 h-14">
                          <!-- No se mostrará ninguna imagen -->
                        </div>
                        <div class="ml-4">
                          <div class="text-sm leading-5 font-medium text-gray-900">{{ project.title }}</div>
                          <div class="text-sm leading-5 text-gray-500">{{ $t('community.updated_at') }}
                            {{ $moment(project.updated_at).format("LLLL") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Si se ha seleccionado un producto / curso -->
            <div v-show="this.projectSelected.title !== ''" class="h-full flex flex-col shadow-xl">
              <div class="bg-bpblue py-6">
                <span class="mt-4 ml-6 text-white font-bold text-2xl">Curso seleccionado</span>
              </div>
              <div class=" w-full border-t border-blue-200"></div>

              <div class="flex items-center bg-blue-100">
                <div class="mt-4 mb-4 ml-6 text-gray-700 font-bold text-lg">

                </div>
                <div class="ml-7 py-4">
                  <div class="text-sm leading-5 font-medium text-gray-900">{{ this.projectSelected.title }}</div>
                  <div class="text-sm leading-5 text-gray-500">{{ $t('community.updated_at') }}
                    {{ $moment(this.projectSelected.updated_at).format("LLLL") }}
                  </div>
                </div>
              </div>
              <div class="w-full border-t border-blue-200"></div>
              <div class="mt-6 ml-6 space-y-5">
                <div class="relative flex items-start">
                  <div class="absolute flex items-center h-5">
                    <input id="role_student" v-on:change="changeNewUserRol" name="user-role-selector" v-model="user.rol"
                           type="radio" class="focus:ring-bpblue h-4 w-4 text-bpblue border-gray-300" value="student"
                           checked>
                  </div>
                  <div class="pl-7 text-sm">
                    <label for="role_student" class="font-medium text-gray-900">
                      {{ $t('panels.student') }}
                    </label>
                    <p id="privacy_public_description" class="text-gray-500">
                      {{ $t('panels.user_as_student') }}
                    </p>
                  </div>
                </div>
                <div>
                  <div class="relative flex items-start">
                    <div class="absolute flex items-center h-5">
                      <input id="role_editing_teacher" v-on:change="changeNewUserRol" name="user-role-selector"
                             v-model="user.rol" type="radio"
                             class="focus:ring-bpblue h-4 w-4 text-bpblue border-gray-300" value="editing-teacher">
                    </div>
                    <div class="pl-7 text-sm">
                      <label for="role_editing_teacher" class="font-medium text-gray-900">
                        {{ $t('panels.teacher') }}
                      </label>
                      <p id="role_editing_teacher_description" class="text-gray-500">
                        {{ $t('panels.user_as_teacher') }}
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="relative flex items-start">
                    <div class="absolute flex items-center h-5">
                      <input id="role_teacher" v-on:change="changeNewUserRol" name="user-role-selector"
                             v-model="user.rol" type="radio"
                             class="focus:ring-bpblue h-4 w-4 text-bpblue border-gray-300" value="teacher">
                    </div>
                    <div class="pl-7 text-sm">
                      <label for="role_teacher" class="font-medium text-gray-900">
                        {{ $t('panels.teacher_no_edition') }}
                      </label>
                      <p id="role_teacher_description" class="text-gray-500">
                        {{ $t('panels.user_as_teacher_no_edition') }}
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="relative flex items-start">
                    <div class="absolute flex items-center h-5">
                      <input id="role_inspector" v-on:change="changeNewUserRol" name="user-role-selector"
                             v-model="user.rol" type="radio"
                             class="focus:ring-bpblue h-4 w-4 text-bpblue border-gray-300" value="inspector">
                    </div>
                    <div class="pl-7 text-sm">
                      <label for="role_inspector" class="font-medium text-gray-900">
                        {{ $t('panels.inspector') }}
                      </label>
                      <p class="text-gray-500">
                        {{ $t('panels.user_as_inspector') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div v-if="user.rol === 'student'" class="mt-6 py-2">
                  <div class="w-full border-t border-gray-200"></div>
                  <fieldset>
                    <div class="mt-4 space-y-4">
                      <div class="relative flex items-start">
                        <div class="flex items-center pl-6 h-5">
                          <input id="notificate-checkbox" v-model="user.notify" name="notificate-checkbox"
                                 type="checkbox" class="focus:ring-bpblue h-4 w-4 text-bpblue border-gray-300"/>
                        </div>
                        <div class="ml-3 text-sm">
                          <label for="notificate-checkbox"
                                 class="font-medium text-gray-700">{{ $t('panels.email_notification') }}</label>
                          <p class="text-gray-500">Envía al usuario una notificación de matriculación.</p>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <div class="mt-4 w-full border-t border-gray-200"></div>
                </div>
                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                  <button type="button" v-on:click="closeEnrolSlideOver"
                          class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
                    Volver
                  </button>
                  <button type="button" v-on:click="setEnroll(this.projectSelected)" :disabled="this.loading"
                          class="inline-flex items-center ml-6 px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-bpblue hover:bg-blue-400">
                    Matricular
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import {useAuthUserStore} from "@/stores/auth";
import {useAcademiesStore} from "@/stores/academies";
import projectService from "@/services/project/ProjectService";
import enrolService from "@/services/enrol/EnrolService";
import {useNavigationMenuStore} from "@/stores/navigationMenu";


export default {
  name: "UserEnrollComponent",
  data: () => {
    return {
      loading: false,
      projects: [],
      projectSelected: {
        products: [{
          media: {
            video: '',
            thumbnail: '',
            thumbnail_handle: ''
          },
          title: '',
          uuid: ''
        }],
        title: '',
        uuid: '',
      },
      user: {
        academy_uuid: null,
        firstname: null,
        lastname: null,
        email: null,
        password: null,
        phone: null,
        identity_card: null,
        rol: "student",
        project_uuid: null,
        notify: false
      },
    }
  },
  setup() {
    const authUserStore = useAuthUserStore();
    const academiesStore = useAcademiesStore();
    const navigationMenuStore = useNavigationMenuStore();

    return {
      authUserStore,
      academiesStore,
      navigationMenuStore
    }
  },
  mounted() {
    this.getProjects()
  },
  methods: {
    getProjects() {
      this.loading = true
      let academy_uuid = this.academiesStore.academy.uuid;
      projectService.index(academy_uuid)
          .then((response) => {
            console.log("Projectos para matricular: ", response.data.data)
            this.projects = response.data.data
            this.loading = false
          })
    },
    getProjectSelected(project) {
      this.projectSelected = project
      console.log("Proyecto seleccionado: ", project)
    },
    changeNewUserRol() {
      if (this.user.rol !== 'student') {
        this.user.notify = false
      }
    },
    closeEnrolSlideOver() {
      this.navigationMenuStore.toggleSlideOverEnrolUser()
      this.projects = []
      this.getProjects()
      this.projectSelected.title = ''
    },
    setEnroll(project) {
      this.loading = true
      let enrolRequest = {
        project_uuid: project.uuid,
        academy_user_uuid: this.$route.params.id,
        notify: this.user.notify,
        rol: this.user.rol
      }
      console.log("La petición de matriculación es: ", enrolRequest)
      //TODO enrol-is-loading
      this.$emit('enrol-toggle-loading', true)
      enrolService.post(enrolRequest)
          .then((response) => {
            console.log("La respuesta de la matriculación es: ", response)
            //Se cierra la ventana.
            setTimeout(() => {
              this.$emit('reload-enrols', true)
            }, 5500)
            this.navigationMenuStore.toggleSlideOverEnrolUser()
          })
          .catch((error) => {
            console.log("Error en la matriculación: ", error)
          })
          .finally(() => {
            this.loading = false
            setTimeout(() => {
              this.$emit('enrol-toggle-loading', false)
            }, 5500)
          })
    },
  }
}
</script>

<style scoped>

</style>